import { render, staticRenderFns } from "./StockReportComponent.vue?vue&type=template&id=5e4331ac&scoped=true"
import script from "./StockReportComponent.vue?vue&type=script&lang=js"
export * from "./StockReportComponent.vue?vue&type=script&lang=js"
import style0 from "./StockReportComponent.vue?vue&type=style&index=0&id=5e4331ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4331ac",
  null
  
)

export default component.exports